var map = {
	"./footer-b-shape.svg": "./src/img/footer-b-shape.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./src/img/icon-stuurlui-global.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";